<div
  translate="m/task-process/task-actions-log/confirm-steal/message"
  [translateParams]="{ user: adminUser.name }"></div>
<div class="footer">
  <ion-button (click)="ok()">
    <span translate="m/task-process/task-actions-log/confirm-steal/ok-button"></span>
  </ion-button>
  <ion-button (click)="cancel()" fill="outline">
    <span translate="m/cancel"></span>
  </ion-button>
</div>
